import * as firebase from "firebase"
require("firebase/firestore")

export const incrementView = id_video => {
  return firebase.firestore().collection('videos').doc(id_video).update('views', firebase.firestore.FieldValue.increment(1))
}

export const getNewsVideos = (days) => {
  let date = new Date()
  date.setDate(date.getDate() - days)
  let min_date = firebase.firestore.Timestamp.fromDate(date)

  return (
    firebase.firestore().collection('videos')
    .where('created_at', '>=', min_date)
    //Where PLAN
    .get()
    .then(snapshot => {
      let results = []

      snapshot.forEach(async doc => {
        let data = doc.data()
        results.push({
          id: doc.id,
          ...data
        })
      })
      return results
    })
    .catch(error => {
      throw error
    })
  )
}

export const getDocumentsFromCollection = (collection, references) => {
  let collectionRef = firebase.firestore().collection(collection)
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(async doc => {
          let data = doc.data()

          if (references) {
            for (let reference of references) {
              if (data[reference]) {
                if (Array.isArray(data[reference])) {
                  let refs_data = []
                  for (let ref of data[reference]) {
                    await ref.get().then(reference_result => {
                      let reference_data = reference_result.data()
                      reference_data.id = reference_result.id
                      refs_data.push(reference_data)
                    })
                  }
                  data[reference] = refs_data
                } else {
                  await data[reference].get().then(reference_result => {
                    let reference_data = reference_result.data()
                    reference_data.id = reference_result.id
                    data[reference] = reference_data
                  })
                }
              }
            }
          }

          results.push({
            id: doc.id,
            ...data
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const getCategoriesByComponent = id => {
  let component = getDocById('components', id)

  let collectionRef = firebase.firestore().collection('categories')
  return (
    collectionRef.where('component', '==', component)
      .get()
      .then(querySnapshot => {
        let results = []
        querySnapshot.forEach(doc => {
          results.push({
            id: doc.id,
            ...doc.data()
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const createVideo = video => {
  let document = firebase.firestore().collection("videos").doc()
  return document
    .set({
      name: video.name,
      description: video.description,
      component: video.component,
      category: video.category,
      plans: video.plans,
      views: 0,
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      updated_at: firebase.firestore.FieldValue.serverTimestamp()
    })
    .then(() => {
      return document
    })
    .catch(error => {
      console.log('C', error)
      throw error
    })
}

export const updateVideo = video => {
  let document = firebase.firestore().collection("videos").doc(video.id)
  return document
    .update({
      name: video.name,
      description: video.description,
      component: video.component,
      category: video.category,
      plans: video.plans,
      updated_at: firebase.firestore.FieldValue.serverTimestamp()
    })
    .then(() => {
      return document
    })
    .catch(error => {
      console.log('B', error)
      throw error
    })
}

export const getVideoTerms = (name, description) => {
  let name_terms = name.split(" ")
  let description_terms = description.split(" ")
  let words = name_terms.concat(description_terms)
  words = words.map(v => v.toLowerCase());
  return words.filter((v, i, a) => a.indexOf(v) === i)
  // words = words.filter((v, i, a) => a.indexOf(v) === i)
  // let terms = {}
  // for (let word of words) {
  //   terms[word] = true
  // }
  // return terms
}

export const updateVideoThumbnail = id => {
  let document = firebase.firestore().collection("videos").doc(id)
  return document
    .update({
      image: 'video/' + id + '.jpg'
    })
}

export const updateVideoName = id => {
  let document = firebase.firestore().collection("videos").doc(id)
  return document
    .update({
      video: 'video/' + id + '.mp4'
    })
}

export const updateVideoResource = id => {
  let document = firebase.firestore().collection("videos").doc(id)
  return document
    .update({
      image: 'video/' + id + '.mp4'
    })
}

export const removeVideo = id => {
  let document = firebase.firestore().collection("videos").doc(id)
  return document
    .delete()
    .then(() => {
      return true
    })
    .catch(error => {
      console.log('A', error)
      throw error
    })
}
